export default {
   ApplProcs: [
      {
         membertype: "ASC",
         proc: [
            { id: 1, desc: "Only application submitted online using MIP Platform will be processed." },
            { id: 2, desc: "Application should submit certified copies of certificates and other relevant documents in support of the applications." },
            { id: 3, desc: "Application must be accompanied by payment for entrance fee and annual subscription fee determined by MIP which is payable at the time of applying." },
            { id: 4, desc: "Only completed forms with all necessary documents will be processed." },
         ]
      },
      {
         membertype: "STU",
         proc: [
            { id: 1, desc: "Only application submitted online using MIP Platform will be processed." },
            { id: 2, desc: "Application should submit certified copies of certificates and other relevant documents in support of the applications." },
            { id: 3, desc: "Application must be accompanied by payment for entrance fee and annual subscription fee determined by MIP which is payable at the time of applying." },
            { id: 4, desc: "Only completed forms with all necessary documents will be processed." },
         ]
      },
      {
         membertype: "GRA",
         proc: [
            { id: 1, desc: "Only application submitted online using MIP Platform will be processed." },
            { id: 2, desc: "Application should submit certified copies of certificates and other relevant documents in support of the applications." },
            { id: 3, desc: "Application must be accompanied by payment for entrance fee and annual subscription fee determined by MIP which is payable at the time of applying." },
            { id: 4, desc: "Only completed forms with all necessary documents will be processed." },
         ]
      },
      {
         membertype: "COR",
         proc: [
            { id: 1, desc: "Only application submitted online using MIP Platform will be processed." },
            { id: 2, desc: "Application should submit certified copies of certificates and other relevant documents in support of the applications." },
            { id: 3, desc: "Application must be accompanied by payment for entrance fee and annual subscription fee determined by MIP which is payable at the time of applying." },
            { id: 4, desc: "Application for corporate membership must be accompanied by the log sheet which is to be maintained by the graduate member for a minimum of one year." },
            { id: 5, desc: "Only completed forms with all necessary documents will be processed." },
         ]
      },
      {
         membertype: "PAT",
         proc: [
            { id: 1, desc: "Only application submitted online using MIP Platform will be processed." },
            { id: 2, desc: "Application should submit certified copies of certificates and other relevant documents in support of the applications." },
            { id: 3, desc: "Application must be accompanied by payment for entrance fee and annual subscription fee determined by MIP which is payable at the time of applying." },
            { id: 4, desc: "Only completed forms with all necessary documents will be processed." },
         ]
      },
   ]
}
